'use es6';
/*******************************************************************
calculate vertical margin based on percentage against width, because
measurements are relative to width, not height
*******************************************************************/

export const toScaledPercentage = (dimensions, side) => `${dimensions[side] / dimensions.width * 100}%`;